<template>
    <transition name="layout-fade">
        <v-layout wrap>
            <Navigation @syncError="loading = false" @syncComplete="syncComplete" @syncStarted="loading = true"/>

            <v-slide-y-transition mode="out-in">
                <router-view/>
            </v-slide-y-transition>

            <v-dialog v-model="loading" width="300">
                <v-card color="secondary" dark>
                    <v-card-text>
                        Пожалуйста подождите
                        <v-progress-linear indeterminate color="primary" class="mb-0"/>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </transition>
</template>

<script>
import Navigation from './Navigation'

export default {
    name: 'CatalogLayout',
    components: { Navigation },
    data () {
        return {
            loading: false
        }
    },

    created () {
        this.setHeaderTitle('Каталог')
    },

    methods: {
        syncComplete () {
            this.loading = false

            this.$store.commit('showSnackbar', {
                text: 'Успех! Продукты синхронизированы, страница будет перезагружена автоматически в течении 5 сек.',
                color: 'success'
            })

            setTimeout(() => {
                location.reload()
            }, 5000)
        }
    }
}
</script>
